if (!customElements.get('product-variant-dropdown')) {
  customElements.define(
    'product-variant-dropdown',
    class ProductVariantDropdown extends HTMLElement {
      connectedCallback() {
        this.nativeSelect = this.previousElementSibling;
        this.trigger = this.querySelector('.product-variant-dropdown__trigger');
        this.options = this.querySelector('.product-variant-dropdown__options');
        this.optionButtons = Array.from(this.querySelectorAll('.product-variant-dropdown__option'));

        if (!this.nativeSelect?.matches('select') || !this.trigger || !this.options) return;

        this.nativeSelect.classList.add('is-enhanced');
        this.nativeSelect.tabIndex = -1;
        this.nativeSelect.setAttribute('aria-hidden', 'true');

        this.onTriggerClick = () => this.toggle();
        this.onOptionClick = this.handleOptionClick.bind(this);
        this.onDocumentClick = this.handleDocumentClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);

        this.trigger.addEventListener('click', this.onTriggerClick);
        this.options.addEventListener('click', this.onOptionClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('click', this.onDocumentClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClick);
        this.options?.removeEventListener('click', this.onOptionClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('click', this.onDocumentClick);
      }

      toggle(forceOpen) {
        const shouldOpen = forceOpen ?? !this.classList.contains('is-open');
        this.classList.toggle('is-open', shouldOpen);
        this.options.hidden = !shouldOpen;
        this.trigger.setAttribute('aria-expanded', String(shouldOpen));

        if (shouldOpen) {
          this.optionButtons.find((option) => option.getAttribute('aria-selected') === 'true')?.focus();
        }
      }

      handleOptionClick(event) {
  const button = event.target.closest(
    '.product-variant-dropdown__option'
  );

  if (!button || button.disabled) return;

  event.preventDefault();

  const nativeOption = Array.from(this.nativeSelect.options).find(
    (option) => option.value === button.dataset.value
  );

  if (!nativeOption || nativeOption.disabled) return;

  const changed = this.nativeSelect.value !== nativeOption.value;

  this.nativeSelect.value = nativeOption.value;

  const label = this.trigger.querySelector('[data-dropdown-label]');

  if (label) {
    label.textContent = nativeOption.value
      .split('|')
      .map((part) => part.trim())
      .join(' | ');
  }

  this.optionButtons.forEach((optionButton) => {
    const selected =
      optionButton.dataset.value === nativeOption.value;

    optionButton.classList.toggle('is-selected', selected);
    optionButton.setAttribute('aria-selected', String(selected));
  });

  this.toggle(false);
  this.trigger.focus();

  // Dispatch last because the theme may replace this dropdown.
  if (changed) {
    this.nativeSelect.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
}

      handleDocumentClick(event) {
        if (!this.contains(event.target)) this.toggle(false);
      }

      handleKeydown(event) {
        if (event.key === 'Escape' && this.classList.contains('is-open')) {
          event.preventDefault();
          this.toggle(false);
          this.trigger.focus();
        }
      }
    }
  );
}
